import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

export type HoverText = { title: string; description: string }
export interface RoomHoverTextProps {
  title: string
  description: string
}
export const RoomHoverText: React.FC<RoomHoverTextProps> = ({ title, description }) => (
  <AnimatePresence>
    <StoryTextWrapper
      key={title}
      initial={{ y: '10%', opacity: 0 }}
      animate={{ y: '0%', opacity: 1, transition: { duration: 0.55 } }}
      exit={{ y: '-10%', opacity: 0, transition: { duration: 0.2 } }}
    >
      {title && <StoryTextName>{title}</StoryTextName>}
      {description && <StoryTextDescription>{description}</StoryTextDescription>}
    </StoryTextWrapper>
  </AnimatePresence>
)

export default RoomHoverText

const StoryTextWrapper = styled(motion.div)`
  position: absolute;
  width: 100vw;
  bottom: 12vh;
  transform: translate3d(0px, 0px, -500px);
  z-index: 1000;
`

const StoryTextName = styled.h2`
  max-width: 50vw;
  font-size: calc(40px + 0.8vw);
  font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
  color: #fff;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 125%;
  text-align: center;
  margin-bottom: 0.312em;
  margin: 0 auto 0.312em auto;
`

const StoryTextDescription = styled.p`
  max-width: 50vw;
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  font-size: calc(18px + 0.3vw);
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.5;
  text-align: center;
  margin: 0 auto;
`
